import type { DateRangePreset } from './types';

// Named preset constants. Prefer these over positional indexing of the preset
// arrays so that new presets can be added without renumbering every caller.
export const FIVE_MINUTE_PRESET: DateRangePreset = { unit: 'minutes', quantity: 5 };
export const FIFTEEN_MINUTE_PRESET: DateRangePreset = { unit: 'minutes', quantity: 15 };
export const ONE_HOUR_PRESET: DateRangePreset = { unit: 'minutes', quantity: 60 };
export const FOUR_HOUR_PRESET: DateRangePreset = { unit: 'hours', quantity: 4 };
export const ONE_DAY_PRESET: DateRangePreset = { unit: 'hours', quantity: 24 };
export const SEVEN_DAY_PRESET: DateRangePreset = { unit: 'days', quantity: 7 };
export const THIRTY_DAY_PRESET: DateRangePreset = { unit: 'days', quantity: 30 };
export const THREE_MONTH_PRESET: DateRangePreset = { unit: 'months', quantity: 3 };

export const DEFAULT_TIME_PRESETS: DateRangePreset[] = [
  FIVE_MINUTE_PRESET,
  FIFTEEN_MINUTE_PRESET,
  ONE_HOUR_PRESET,
  FOUR_HOUR_PRESET,
  ONE_DAY_PRESET,
  SEVEN_DAY_PRESET,
  THIRTY_DAY_PRESET,
];

export const EXTENDED_TIME_PRESETS: DateRangePreset[] = [...DEFAULT_TIME_PRESETS, THREE_MONTH_PRESET];
